import { render, staticRenderFns } from "./modifybuilding.vue?vue&type=template&id=47532036&scoped=true&"
import script from "./modifybuilding.vue?vue&type=script&lang=js&"
export * from "./modifybuilding.vue?vue&type=script&lang=js&"
import style0 from "./modifybuilding.vue?vue&type=style&index=0&id=47532036&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47532036",
  null
  
)

export default component.exports